import React from "react";

export default function PlayerOverlayButton({ loadProfile, ign }) {
  return (
    <div class="card_overlay">
      <button class="text" onClick={() => loadProfile(ign)}>
        VIEW
        <br /> PROFILE
      </button>
    </div>
  );
}
